import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Card, Container, Modal, Spinner } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Edit({
  visible,
  newM,
  setNewM,
  setMoamad,
  moamad,
  uEmail,
}) {
  const [displaySave, setDisplaySave] = useState(true);
  const [loading, setLoading] = useState(true);
  const [megdarOptions, setMegdarOptions] = useState([]);
  const [showUpdateExtentiontDate, setShowUpdateExtentiontDate] =
    useState(false);
  const [famOptions, setFamOptions] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const [newEmailToAdd, setNewEmailToAdd] = useState({
    mail_type: "הארכת מועד הגשת מסמכים",
    sender: "",
    subject: "FromDocumentExtentionDate",
    content: "",
    date: "",
    extention_date: null,
    time: "",
    place: null,
    signJob: "",
    signName: "",
    mekhraz: moamad.mekhraz,
    moamad: moamad.id,
  });

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "megdartype/", {
          signal: controller.signal,
        });
        setMegdarOptions(response.data[0].megdarOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
      try {
        const response = await axiosPrivate.get(baseURL + "famtype/", {
          signal: controller.signal,
        });
        setFamOptions(response.data[0].famOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewM((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setDisplaySave(false);
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setNewM((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    setDisplaySave(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isMounted = true;
    const controller = new AbortController();
    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "moamad/" + newM.id + "/",
          newM,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setMoamad(newM);
          setDisplaySave(true);
          setLoading(false);
          alert("העדכון בוצע בהצלחה");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    updateData();
  };

  const handleExtentionDateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let isMounted = true;
    const controller = new AbortController();
    const addData = async () => {
      try {
        const response = await axiosPrivate.post(
          "/jobs/moamademail/",
          newEmailToAdd,
          {
            signal: controller.signal,
          }
        );
        isMounted &&
          setNewM((prevState) => ({
            ...prevState,
            extention_date: newEmailToAdd.extention_date,
          }));
        console.log("Dont delete1");
        setLoading(false);
        alert("המייל נשלח בהצלחה");
        setLoading(false);
        setShowUpdateExtentiontDate(false);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    if (
      newEmailToAdd.mail_type === "הארכת מועד הגשת מסמכים" &&
      (newEmailToAdd.extention_date == null ||
        new Date(newEmailToAdd.extention_date).setHours(0, 0, 0, 0) <
          new Date().setHours(0, 0, 0, 0))
    ) {
      alert(
        "לא בוצעה הארכת מועד לשליחת מסמכים או התאריך קטן מהיום, לא נשלח דואר למועמד."
      );
      setTimeout(() => {
        setLoading(false); // Set loading state after alert
      }, 0);
    } else {
      addData();
    }
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  if (!visible) return;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן...</h3>
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "calc(100vh - 40px)",
          overflowY: "scroll",
        }}
      >
        <Modal
          show={showUpdateExtentiontDate}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header style={{ textAlign: "center" }}>
            <Modal.Title>
              {"הארכת מועד הגשת מסמכי המועמד"}
              <br />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="form-group">
                <label htmlFor="extention_date" style={{ color: "black" }}>
                  תאריך הארכה להגשת מסמכים
                </label>
                <input
                  type="date"
                  name="extention_date"
                  value={newEmailToAdd.extention_date}
                  onChange={(e) => {
                    setNewEmailToAdd((prevState) => ({
                      ...prevState,
                      extention_date: e.target.value, // Use e.target.value instead of e.value
                    }));
                  }}
                  className="form-control"
                  id="extention_date"
                />
              </div>
              <div className="form-group">
                <label htmlFor="content" style={{ color: "black" }}>
                  הערות
                </label>
                <textarea
                  name="content"
                  value={newEmailToAdd.content}
                  onChange={(e) => {
                    setNewEmailToAdd((prevState) => ({
                      ...prevState,
                      content: e.target.value, // Use e.target.value instead of e.value
                    }));
                  }}
                  rows="4"
                  cols="100"
                  className="form-control"
                  id="content"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <button
              className="btn btn-primary"
              onClick={(event) => {
                const now = new Date().setHours(0, 0, 0, 0);
                const extensionDate = new Date(newEmailToAdd.extention_date);
                console.log("before:", extensionDate);
                if (!newEmailToAdd.extention_date) {
                  console.log("after:", newEmailToAdd.extention_date);
                  alert("חייב לציין תאריך להארכה");
                } else if (extensionDate < now) {
                  alert("תאריך לא יכול להיות קטן מהיום");
                } else {
                  handleExtentionDateSubmit(event); // Pass the event object here
                }
              }}
            >
              אשר הארכה
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                setShowUpdateExtentiontDate(false);
              }}
              style={{ marginRight: "auto" }} // Pushes the button to the left
            >
              סגור
            </button>
          </Modal.Footer>
        </Modal>

        <center>
          <Card className="border-danger container px-5" bg="light">
            <Card.Header>
              <h3>עריכת פרטי המועמד</h3>
              <Col sm="3">
                <button
                  className="btn btn-success"
                  onClick={() => setShowUpdateExtentiontDate(true)}
                >
                  הארכת הגשת מסמכים למועמד
                  {newM.extention_date && ` (${newM.extention_date})`}
                </button>
              </Col>
            </Card.Header>
            <Card.Body>
              <form onSubmit={handleSubmit}>
                <Container className="col-sm-10">
                  <Row>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="f_name">שם פרטי</label>
                        <input
                          type="text"
                          name="f_name"
                          value={newM.f_name}
                          onChange={handleChange}
                          className="form-control"
                          id="f_name"
                          placeholder="תקליד שם פרטי"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="father_name">שם אב/אמצעי</label>
                        <input
                          type="text"
                          name="father_name"
                          value={newM.father_name}
                          onChange={handleChange}
                          className="form-control"
                          id="father_name"
                          placeholder="תקליד שם אמצעי"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="l_name">שם משפחה</label>
                        <input
                          type="text"
                          name="l_name"
                          value={newM.l_name}
                          onChange={handleChange}
                          className="form-control"
                          id="l_name"
                          placeholder="תקליד שם משפחה"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="idz">מס תעודת זהות אוטומטי</label>
                        <span style={{ fontWeight: "bold" }}>{newM.idz}</span>
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 4, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="birth_date">תאריך לידה</label>
                        <input
                          type="date"
                          name="birth_date"
                          value={newM.birth_date}
                          onChange={handleChange}
                          className="form-control"
                          id="birth_date"
                          placeholder="תאריך לידה"
                        />
                      </div>
                    </Col>

                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="megdar">מגדר</label>
                        <select
                          name="megdar"
                          onChange={handleChange}
                          value={newM.megdar}
                          required
                        >
                          <option key="0" value="" defaultValue="0">
                            בחר סוג
                          </option>
                          {megdarOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="children_num">מספר ילדים</label>
                        <input
                          type="number"
                          name="children_num"
                          value={newM.children_num}
                          onChange={handleChange}
                          className="form-control"
                          id="children_num"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="fam_status">מצב משפחתי</label>
                        <select
                          name="fam_status"
                          onChange={handleChange}
                          value={newM.fam_status}
                          required
                        >
                          <option key="0" value="">
                            בחר מצב משפחתי
                          </option>
                          {famOptions?.map((a) => (
                            <option key={a[0]} value={a[1]}>
                              {a[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="citizenship">אזרחות</label>
                        <input
                          type="text"
                          name="citizenship"
                          value={newM.citizenship}
                          onChange={handleChange}
                          className="form-control"
                          id="citizenship"
                          placeholder=""
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="special_needs">
                          בעל צרכים מיוחדים?
                        </label>
                        <input
                          type="checkbox"
                          id="special_needs"
                          name="special_needs"
                          checked={newM.special_needs}
                          onChange={handleCheckBoxChange}
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="arab_droze_circassian">
                          נמנה על האוכלוסיה הערבית, הדרוזית או הצרקסית?
                        </label>
                        <input
                          type="checkbox"
                          id="arab_droze_circassian"
                          name="arab_droze_circassian"
                          checked={newM.arab_droze_circassian}
                          onChange={handleCheckBoxChange}
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="ethiopian">אתיופי?</label>
                        <input
                          type="checkbox"
                          id="ethiopian"
                          name="ethiopian"
                          checked={newM.ethiopian}
                          onChange={handleCheckBoxChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="mobile_phone">מספר נייד</label>
                        <input
                          type="text"
                          name="mobile_phone"
                          value={newM.mobile_phone}
                          onChange={handleChange}
                          className="form-control"
                          id="mobile_phone"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="mobile_phone">טלפון בעבודה</label>
                        <input
                          type="text"
                          name="work_phone"
                          value={newM.work_phone}
                          onChange={handleChange}
                          className="form-control"
                          id="work_phone"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="home_phone">טלפון בבית</label>
                        <input
                          type="text"
                          name="home_phone"
                          value={newM.home_phone}
                          onChange={handleChange}
                          className="form-control"
                          id="home_phone"
                          placeholder=""
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="Address">כתובת</label>
                        <input
                          type="text"
                          name="Address"
                          value={newM.Address}
                          onChange={handleChange}
                          className="form-control"
                          id="Address"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="zipcode">מיקוד</label>
                        <input
                          type="text"
                          name="zipcode"
                          value={newM.zipcode}
                          onChange={handleChange}
                          className="form-control"
                          id="zipcode"
                          placeholder="כמו 3"
                        />
                      </div>
                    </Col>
                    <Col sm="3" md={{ size: 3, offset: 1 }}>
                      <div className="form-group">
                        <label htmlFor="userEmail">
                          דואר אלקטרוני-אוטומטי-
                        </label>
                        <span style={{ fontWeight: "bold" }}>{uEmail}</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="moamad_notes">
                          משהו טוב שרוצה לספר
                        </label>
                        <textarea
                          name="moamad_notes"
                          cols={50}
                          rows={2}
                          value={newM.moamad_notes}
                          onChange={handleChange}
                          className="form-control"
                          id="moamad_notes"
                        />
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={displaySave}
                  >
                    שמור
                  </button>
                </Container>
              </form>
            </Card.Body>
          </Card>
        </center>
      </div>
    );
  }
}
